export const MASTERDATA_TYPE = {
  COUNTRY: "COUNTRY",
  PAYMENT_METHOD: "PAYMENT_METHOD",
  CURRENCY: "CURRENCY",
  TERM_TYPE: "TERM_TYPE",
  NUM_OF_INSTALLMENT: "NUM_OF_INSTALLMENT",
  EVENT_TYPE: "EVENT_TYPE",
  TIMING: "TIMING",
  ABSOLUTE_DRIVER: "ABSOLUTE_DRIVER",
  CALCULATION_BASIS: "CALCULATION_BASIS",
  NOMINAL_ACCOUNT_DEBIT: "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_DEBIT",
  NOMINAL_ACCOUNT_DEBIT_All: "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_DEBIT&premiereGolfNominal=all",
  NOMINAL_ACCOUNT_CREDIT: "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_CREDIT",
  UNDERS_OVERS_AUTO_MATCH: "PAYMENT_TERM_RULE_UNDERS_OVERS_AUTO_MATCH",
} as const;
